var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "#A8ABC2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "IONIcon/A/arrow",
    d: "M10.7073 6.07619C11.4242 6.54943 11.7827 6.78605 11.9117 7.08018C12.0294 7.34882 12.0294 7.65118 11.9117 7.91982C11.7827 8.21395 11.4242 8.45057 10.7073 8.9238L2.85361 14.1075C1.93929 14.711 1.48213 15.0127 1.10208 14.9996C0.75638 14.9877 0.434932 14.8273 0.227756 14.5633C-1.68085e-07 14.2732 -1.52045e-07 13.7434 -1.01123e-07 12.6837L3.97069e-07 2.31632C4.47991e-07 1.25663 4.66629e-07 0.726789 0.227757 0.436653C0.434933 0.172733 0.75638 0.0123472 1.10208 0.000410032C1.48213 -0.0127145 1.93929 0.289028 2.85361 0.892513L10.7073 6.07619Z",
    fill: "#A8ABC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkExpand);
export default __webpack_public_path__ + "static/media/darkExpand.170c7cf290be78a1ba53ba2a25efd15a.svg";
export { ForwardRef as ReactComponent };